import { createSlice } from '@reduxjs/toolkit';

export const patientFeedbackListSlice = createSlice({
  name: 'patientFeedbackList',
  initialState: {
    id: null,
    questions: [],
    message: null,
    isLoading: false,
  },
  reducers: {
    startLoadingPatientFeedbackList: (state) => {
      state.isLoading = true;
    },
    setPatientFeedbackList: (state, action) => {
      state.isLoading = false;
      state.id = action.payload.id;
      state.questions = action.payload.questions;
      state.message = action.payload.message;
    },
  },
});

// Action creators are generated for each case reducer function
export const { startLoadingPatientFeedbackList, setPatientFeedbackList } =
  patientFeedbackListSlice.actions;
